import {
  browserTracingIntegration,
  init,
  setTags,
} from '@sentry/angular';
import { environment } from '../../../../environments/environment';
import type { SentryMonitoringConfig } from './sentry-environment.model';

export type AppSurface = 'website' | 'admin';

export function getSentryConfig(): SentryMonitoringConfig | undefined {
  return (environment as { monitoring?: { sentry?: SentryMonitoringConfig } })
    .monitoring?.sentry;
}

export function isSentryEnabled(): boolean {
  const cfg = getSentryConfig();
  return !!cfg?.enabled && !!cfg.dsn?.trim();
}

/** Call from main.ts before Angular bootstraps (browser only). */
export function initSentryFromEnvironment(appSurface: AppSurface): void {
  if (typeof globalThis.window === 'undefined') {
    return;
  }
  const cfg = getSentryConfig();
  if (!cfg?.enabled || !cfg.dsn?.trim()) {
    return;
  }

  const tracesSampleRate = cfg.tracesSampleRate ?? 0;

  init({
    dsn: cfg.dsn.trim(),
    environment: cfg.deploymentEnv,
    release: cfg.release?.trim() || undefined,
    tracesSampleRate,
    integrations:
      tracesSampleRate > 0 ? [browserTracingIntegration()] : [],
  });

  setTags({
    app_surface: appSurface,
    tenant_name: environment.tenant_Name,
    theme_name: environment.theme_name ?? 'unknown',
  });
}
